const normalizedCategory = category => typeof category === "string"
  ? category.trim().toUpperCase()
  : "";

export const getScratchCardOrganization = ssce => {
  const organizations = [ssce?.organization, ssce?.examType?.organization];
  const necoOrganizationWithId = organizations.find(organization =>
    normalizedCategory(organization?.category) === "NECO" && organization?.id != null
  );

  return necoOrganizationWithId
    || organizations.find(organization => organization?.id != null)
    || organizations.find(Boolean)
    || null;
};

export const isNecoSSCE = ssce => [
  ssce?.organization?.category,
  ssce?.examType?.organization?.category
].some(category => normalizedCategory(category) === "NECO");

export const hasCompletedScratchCardPin = pin => typeof pin === "string"
  ? pin.trim().length > 0
  : Boolean(pin);

export const hasCompletedScratchCardSSCE = ssce => hasCompletedScratchCardPin(ssce?.scratchCardPin);

export const getPurchaseScratchCardSSCEs = (ssces = []) => ssces.filter(isNecoSSCE);

export const getManualScratchCardSSCEs = (ssces = []) =>
  ssces.filter(ssce => !isNecoSSCE(ssce));

export const hasPendingPurchaseScratchCardSSCE = (ssces = []) => getPurchaseScratchCardSSCEs(ssces)
    .some(ssce => !hasCompletedScratchCardSSCE(ssce));

export const hasPendingManualScratchCardSSCE = (ssces = []) =>
  getManualScratchCardSSCEs(ssces).some(ssce => !hasCompletedScratchCardSSCE(ssce));

export const areScratchCardDetailsComplete = ({
  ssces = []
} = {}) => {
  if (ssces.length === 0) return true;

  return !hasPendingPurchaseScratchCardSSCE(ssces)
    && !hasPendingManualScratchCardSSCE(ssces);
};
